import styled from 'styled-components'

const PlainButton = styled.button`
  display: inline-block;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: inherit;
`

export { PlainButton }
